export default __webpack_public_path__ + "static/media/youtube-dark.b153ea70.svg";